// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__a-eJy","resendInfoText":"OnGoingPaymentBox_resendInfoText__13kpH"};